<template>
  <div style="" class="login--background">
    <div class="container-fluid">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
      ></loading>
      <register-screen
        v-bind:isActive="active"
        v-on:switchActive="active = false"
      ></register-screen>
      <div class="row" v-if="!active">
        <div class="col-lg-6 col-12" style="background: white; height: 100vh">
          <div class="login--wrap">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="login--logo">
                    <Logo />
                  </div>
                  <span class="head login--title">Welcome Back</span>
                  <br />
                  <span class="head--sub"
                    >Sign in to your DemoBottle Account.</span
                  >
                  <form class="login--form" method="post">
                    <input
                      class="input--text email login--input-bottom"
                      type="email"
                      v-model="email"
                      placeholder="Email adres"
                      name="email"
                    />
                    <input
                      class="input--text password login--input-bottom"
                      type="password"
                      v-model="password"
                      placeholder="Password"
                      name="password"
                    />
                  </form>
                </div>
                <div class="col-lg-12 col-12">
                  <span
                    class="form--error"
                    v-for="error in errors"
                    :key="error"
                  >
                    {{ error }}
                    <br />
                  </span>
                  <button
                    class="btn btn-primary login--button-main"
                    @click="login"
                  >
                    Sign In
                  </button>
                  <a href="https://form.typeform.com/to/rMF53YsW"
                    ><button
                      class="btn btn-dark login--button-second"
                    >
                      Try DemoBottle
                    </button></a
                  >
                  <div class="login--forgot">Forgot password.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Logo from "../components/Logo";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import RegisterScreen from "./Register.vue";
export default {
  name: "login",
  components: {
    Loading,
    Logo,
    RegisterScreen: RegisterScreen,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      errors: null,
      email: null,
      password: null,
      active: false,
    };
  },
  methods: {
    login() {
      var self = this;
      this.isLoading = true;

      axios({
        method: "POST",
        crossdomain: true,
        headers: { "Content-Type": "Content-Type:application/json" },
        url: "https://api.demobottle.com/user/login",
        data: {
          email: self.email,
          password: self.password,
        },
        body: {
          email: self.email,
          password: self.password,
        },
      })
        .then(function (response) {
          self.isLoading = false;
          localStorage.token = response.data.token.access_token;
          //this.$globals.organization_id = response.data.user.organizations[0];
          //this.$globals.userOrganizations = response.data.user.organizations;
          self.$router.push("/");
        })
        .catch(function (error) {
          self.errors = error.data;
          self.isLoading = false;
        });
    },

    register() {
      this.active = true;
    },
  },
};
</script>
